export const TENTH_ANNIVERSARY_KEY_CHAINS_SKU = 'YSK25208CP12';
